import * as React from 'react';
import { Image, ImageResizeOptions } from '../Image';
import { classes, st } from './HeroImage.st.css';
import { HeroImageDefaultProps, HeroImageProps } from './types';

/** HeroImage is a component representing a header with high presence providing context about the page content */
export class HeroImage extends React.Component<HeroImageProps> {
  static displayName = 'HeroImage';
  static defaultProps: HeroImageDefaultProps = {
    resize: ImageResizeOptions.cover,
  };

  render() {
    const { className, ...imageProps } = this.props;

    return <Image className={st(classes.root, className)} {...imageProps} />;
  }
}
